import env from 'env';
import * as Sentry from '@sentry/react';

export default {
  init() {
    if (env.SENTRY_DSN_URL) {
      Sentry.init({
        dsn: env.SENTRY_DSN_URL,
        environment: env.SENTRY_ENV,
      });
    }
  },
};
